import { inject } from 'tsyringe'
import { containerScoped } from '~/decorators/dependency-container'
import { RelatedClassifiedsResult } from '~/models/classified/related'
import RequestBuilder from '~/builders/http/RequestBuilder'
import { formatFeed } from '~/services/user/formatters'
import { toCamelCase } from '~/utils/object'

@containerScoped()
export default class RelatedClassifiedsService {
  constructor(
    @inject(RequestBuilder)
    private requestBuilder: RequestBuilder
  ) {}

  getRelatedClassifieds(
    classifiedId: number
  ): Promise<RelatedClassifiedsResult> {
    return this.requestBuilder
      .request('get', `/api/classifieds/${classifiedId}/related/`)
      .map(body => this.formatRelatedClassifieds(body.data))
      .send()
  }

  formatRelatedClassifieds(r: any): RelatedClassifiedsResult {
    return {
      feeds: r.feeds?.map(formatFeed),
      searches: toCamelCase(r.searches)
    }
  }
}
